// Importing Common API rules
import { httpClient } from '@/modules/shared/services';
// Users API Links
import { apiConstants } from '../config';

export default class ClientResource
{

	getClientDetails(id)
	{
		return httpClient.get(this.makeUrl(apiConstants.get_client_details, id));
	}

	saveMerchantInfo(payload)
	{
		return httpClient.post('client/merchant-info', payload);
	}

	getPageData(id, page) {
		console.log('getPageDataId:', id);
		return httpClient.get(this.makeUrl(apiConstants[page], id));
	}

	insertData(payload, page, id=null) {
		console.log('addClientData:', payload);
		// If inserting merchant_info, client_id should be null
		if(id == null)
		{
			if(page == 'merchant_info')
			{
				return httpClient.post('client/' + apiConstants[page], { data: payload });
			}
		}
		// if inserting any other type of data, client_id shouldn't be null
		else
		{
			if(page != 'merchant_info')
			{
				return httpClient.post(this.makeUrl(apiConstants[page], id), { data: payload })
			}
		}

		console.log('Confusion with ids while inserting :(');
		return false;
	}

	editField(id, payload, apiUrl) {
		console.log('id:', id);
		console.log('payload:', payload);
		console.log('apiUrl:', apiConstants[apiUrl]);
		return httpClient.put(this.makeUrl(apiConstants[apiUrl], id), {data: payload});
	}

	removeDoNotCall(clientId)
	{
		return httpClient.put('client/' + clientId + '/remove-do-not-call');
	}

	// searchClients(payload) {
	// 	return httpClient.post('client/search', {data: payload});
	// }

	searchClients(page=null, query=null)
    {
        console.log('page:', page);
        console.log('query:', query);

        var link = 'client/search';

        if(query) link = link+'?page='+ page + '&q=' + query;

        return httpClient.get(link);
    }

	getEntityClosers(entityId)
	{
		return httpClient.get('entity/' + entityId + '/closers');
	}

	makeUrl(url, id) {
		return 'client/' + id + '/' + url;
	}

	////////////////////////////////////////////
	//////////// CLIENT STATUS /////////////////
	////////////////////////////////////////////

	showClientStatusDetails(clientId, clientStatusId)
	{
		return httpClient.get('client/' + clientId + '/client-status/' + clientStatusId);
	}

	showUnlistedClientStatusDetails(clientId)
	{
		return httpClient.get('client/' + clientId + '/client-status/unlisted');
	}

	updateClientStatusDetails(clientId, clientStatusId, payload)
	{
		return httpClient.post('client/' + clientId + '/client-status/' + clientStatusId, payload);
	}

	getClientStatusOptions(clientStatusId)
	{
		return httpClient.get(apiConstants.list_client_status_options + '/' + clientStatusId + '/options');
	}


	////////////////////////////////////////////
	////////////// LEAD QUEUES /////////////////
	////////////////////////////////////////////

	getUnlistedLeadQueuesOfClient(clientId)
	{
		return httpClient.get('client/' + clientId + '/lead-queues/unlisted');
	}

	pushClientToLeadQueue(clientId, leadQueueId, payload)
	{
		return httpClient.post('client/' + clientId + '/lead-queues/' + leadQueueId + '/push', payload);
	}

	////////////////////////////////////////////
	/////////////// OTHER INFO /////////////////
	////////////////////////////////////////////

	addPricingInfo(clientId, pricing_info)
	{
		return httpClient.post('client/' + clientId + '/pricing-info', { data: { pricing_info } });
	}

	getPricingInfo(clientId)
	{
		return httpClient.get('client/' + clientId + '/pricing-info');
	}

	editPricingInfo(clientId, pricing_info)
	{
		return httpClient.put('client/' + clientId + '/pricing-info', { data: { pricing_info } });
	}

	toggleAccountingSoftware(clientId, data)
	{
		return httpClient.post('client/' + clientId + '/accounting-software', data);
	}

	////////////////////////////////////////////
	////////////// Attachments /////////////////
	////////////////////////////////////////////

	getClientAttachmentList(clientId)
	{
		return httpClient.get('client/' + clientId + '/attachments');
	}

	addAttachment(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/attachments', payload);
	}

	editAttachment(clientId, editableId, payload)
	{
		return httpClient.put('client/' + clientId + '/attachments/' + editableId, payload)
	}

	deleteClientAttachment(clientId, clientAttachmentId)
	{
		return httpClient.delete('client/' + clientId + '/attachment/' + clientAttachmentId);
	}

	showClientAttachment(clientId, clientAttachmentId)
	{
		// responseType blob is neede for axios to get pdf files and download them
		return httpClient.get('client/' + clientId + '/attachment/' + clientAttachmentId);
	}

	downloadClientAttachment(clientId, clientAttachmentId)
	{
		// responseType blob is neede for axios to get pdf files and download them
		return httpClient.get('client/' + clientId + '/attachment/' + clientAttachmentId + '/download', {responseType: 'blob'});
	}

	////////////////////////////////////////////
	///////// CLIENT DOCUMENT CENTRE ///////////
	////////////////////////////////////////////
	
	sendDocumentCentreRequestSms(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/document-centre/request-doc/sms', payload);
	}

	sendDocumentCentreRequestEmail(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/document-centre/request-doc/email', payload);
	}

	showClientDocumentCentreFile(clientId, documentCentreId)
    {
        return httpClient.get('client/' + clientId + '/document-centre/' + documentCentreId + '/show-file');
    }

	addDocumentCentreFileToClient(clientId, documentCentreId, payload)
	{
		return httpClient.post('client/' + clientId + '/document-centre/'  + documentCentreId +  '/add', payload);
	}

	////////////////////////////////////////////
	//////////// Custom Mail ///////////////////
	////////////////////////////////////////////

	getCustomMailData(clientId)
	{
		return httpClient.get('client/' + clientId + '/custom-mail');
	}

	sendCustomMail(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/custom-mail', payload);
	}

	getLogs(clientId, filters) {
		return httpClient.get('client/' + clientId + '/logs', { params: { q: filters } });
	}

	getClientDocusign(clientId) {
		return httpClient.get('client/' + clientId + '/docusign');
	}

	////////////////////////////////////////////
	//////////// CLONE DEALS ///////////////////
	////////////////////////////////////////////

	getCloneList(clientId)
	{
		return httpClient.get('client/' + clientId + '/clone/list');
	}

	saveCloneDeal(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/clone', payload);
	}

	////////////////////////////////////////////
	//////////// RESET STATUS //////////////////
	////////////////////////////////////////////

	rollbackCloserStatus(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/rollback-closer-status', payload);
	}

	resetCloserStatus(clientId)
	{
		return httpClient.post('client/' + clientId + '/reset-closer-status');
	}

	/////////////////////////////////////////////
	///////////////// ENTITY ////////////////////
	/////////////////////////////////////////////

	updateClientEntity(clientId, entityId)
	{
		return httpClient.put('client/' + clientId + '/entity/' + entityId);
	}

	////////////////////////////////////////////
	/////////////// HOT LIST ///////////////////
	////////////////////////////////////////////

	toggleClientHotList(clientId)
	{
		return httpClient.post('client/' + clientId + '/hot-list');
	}

	////////////////////////////////////////////
	//////// Reactivate Closed Account /////////
	////////////////////////////////////////////

	getReactivateClient(clientId)
	{
		return httpClient.get('client/' + clientId + '/reactivate');
	}

	updateReactivateClient(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/reactivate', payload);
	}

	////////////////////////////////////////////
	//////////////// Data Entry ////////////////
	////////////////////////////////////////////

	getClientDataEntry(clientId)
	{
		return httpClient.get('client/' + clientId + '/data-entry');
	}

	updateClientDataEntry(clientId, payload)
	{
		return httpClient.put('client/' + clientId + '/data-entry', payload);
	}

	////////////////////////////////////////////
	//////////// Lead Gen History //////////////
	////////////////////////////////////////////

	getLeadGenHistory(clientId)
	{
		return httpClient.get('client/' + clientId + '/lead-gen-history');
	}

	addLeadGenHistory(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/lead-gen-history', payload);
	}

	changeTransferOpener(clientId, payload)
	{
		return httpClient.put('client/' + clientId + '/lead-gen-history/change-opener', payload);
	}

	////////////////////////////////////////////
	//////////////// Transfer //////////////////
	////////////////////////////////////////////


	rejectLiveTransfer(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/transfer/reject-live-transfer', payload);
	}

	////////////////////////////////////////////
	////////////////// VOIP ////////////////////
	////////////////////////////////////////////
	
	initiateCall(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/voip/initiate-call', payload);
	}
	
	////////////////////////////////////////////
	/////////////// AUTO FILL //////////////////
	////////////////////////////////////////////
	
	autoFillMerchantClosureForm(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/auto-fill/merchant-closure-form', payload);
	}
	
	autoFillSimDeactivationForm(clientId, payload)
	{
		return httpClient.post('client/' + clientId + '/auto-fill/sim-deactivation-form', payload);
	}
	
	////////////////////////////////////////////
	/////////////// MID BUYER //////////////////
	////////////////////////////////////////////
	
	getClientMidBuyer(clientId)
	{
		return httpClient.get('client/' + clientId + '/mid-buyer');
	}
	
	setClientMidBuyer(clientId, payload)
	{
		return httpClient.put('client/' + clientId + '/mid-buyer', payload);
	}

	////////////////////////////////////////////
	/////////////// PROCESSOR //////////////////
	////////////////////////////////////////////

	updateClientProcessor(clientId, payload)
	{
		return httpClient.put('client/' + clientId + '/processor', payload);
	}
}
